// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/server/v1/sso.proto (package chalk.server.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_chalk_auth_v1_audit } from "../../auth/v1/audit_pb";
import { file_chalk_auth_v1_permissions } from "../../auth/v1/permissions_pb";
import { file_chalk_utils_v1_sensitive } from "../../utils/v1/sensitive_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file chalk/server/v1/sso.proto.
 */
export const file_chalk_server_v1_sso: GenFile = /*@__PURE__*/
  fileDesc("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", [file_chalk_auth_v1_audit, file_chalk_auth_v1_permissions, file_chalk_utils_v1_sensitive]);

/**
 * @generated from message chalk.server.v1.CreateScimTokenRequest
 */
export type CreateScimTokenRequest = Message<"chalk.server.v1.CreateScimTokenRequest"> & {
};

/**
 * Describes the message chalk.server.v1.CreateScimTokenRequest.
 * Use `create(CreateScimTokenRequestSchema)` to create a new message.
 */
export const CreateScimTokenRequestSchema: GenMessage<CreateScimTokenRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_sso, 0);

/**
 * @generated from message chalk.server.v1.CreateScimTokenResponse
 */
export type CreateScimTokenResponse = Message<"chalk.server.v1.CreateScimTokenResponse"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;
};

/**
 * Describes the message chalk.server.v1.CreateScimTokenResponse.
 * Use `create(CreateScimTokenResponseSchema)` to create a new message.
 */
export const CreateScimTokenResponseSchema: GenMessage<CreateScimTokenResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_sso, 1);

/**
 * @generated from message chalk.server.v1.SsoEmailDomain
 */
export type SsoEmailDomain = Message<"chalk.server.v1.SsoEmailDomain"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string team_id = 2;
   */
  teamId: string;

  /**
   * @generated from field: string email_domain = 3;
   */
  emailDomain: string;

  /**
   * @generated from field: bool chalk_approved = 4;
   */
  chalkApproved: boolean;

  /**
   * @generated from field: repeated string provider_ids = 5;
   */
  providerIds: string[];
};

/**
 * Describes the message chalk.server.v1.SsoEmailDomain.
 * Use `create(SsoEmailDomainSchema)` to create a new message.
 */
export const SsoEmailDomainSchema: GenMessage<SsoEmailDomain> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_sso, 2);

/**
 * @generated from message chalk.server.v1.ListSsoEmailDomainsRequest
 */
export type ListSsoEmailDomainsRequest = Message<"chalk.server.v1.ListSsoEmailDomainsRequest"> & {
};

/**
 * Describes the message chalk.server.v1.ListSsoEmailDomainsRequest.
 * Use `create(ListSsoEmailDomainsRequestSchema)` to create a new message.
 */
export const ListSsoEmailDomainsRequestSchema: GenMessage<ListSsoEmailDomainsRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_sso, 3);

/**
 * @generated from message chalk.server.v1.ListSsoEmailDomainsResponse
 */
export type ListSsoEmailDomainsResponse = Message<"chalk.server.v1.ListSsoEmailDomainsResponse"> & {
  /**
   * @generated from field: repeated chalk.server.v1.SsoEmailDomain email_domains = 1;
   */
  emailDomains: SsoEmailDomain[];
};

/**
 * Describes the message chalk.server.v1.ListSsoEmailDomainsResponse.
 * Use `create(ListSsoEmailDomainsResponseSchema)` to create a new message.
 */
export const ListSsoEmailDomainsResponseSchema: GenMessage<ListSsoEmailDomainsResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_sso, 4);

/**
 * @generated from message chalk.server.v1.CreateSsoEmailDomainRequest
 */
export type CreateSsoEmailDomainRequest = Message<"chalk.server.v1.CreateSsoEmailDomainRequest"> & {
  /**
   * @generated from field: chalk.server.v1.SsoEmailDomain email_domain = 1;
   */
  emailDomain?: SsoEmailDomain;
};

/**
 * Describes the message chalk.server.v1.CreateSsoEmailDomainRequest.
 * Use `create(CreateSsoEmailDomainRequestSchema)` to create a new message.
 */
export const CreateSsoEmailDomainRequestSchema: GenMessage<CreateSsoEmailDomainRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_sso, 5);

/**
 * @generated from message chalk.server.v1.CreateSsoEmailDomainResponse
 */
export type CreateSsoEmailDomainResponse = Message<"chalk.server.v1.CreateSsoEmailDomainResponse"> & {
  /**
   * @generated from field: chalk.server.v1.SsoEmailDomain email_domain = 1;
   */
  emailDomain?: SsoEmailDomain;
};

/**
 * Describes the message chalk.server.v1.CreateSsoEmailDomainResponse.
 * Use `create(CreateSsoEmailDomainResponseSchema)` to create a new message.
 */
export const CreateSsoEmailDomainResponseSchema: GenMessage<CreateSsoEmailDomainResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_sso, 6);

/**
 * @generated from message chalk.server.v1.UpdateSsoEmailDomainRequest
 */
export type UpdateSsoEmailDomainRequest = Message<"chalk.server.v1.UpdateSsoEmailDomainRequest"> & {
  /**
   * @generated from field: chalk.server.v1.SsoEmailDomain email_domain = 1;
   */
  emailDomain?: SsoEmailDomain;
};

/**
 * Describes the message chalk.server.v1.UpdateSsoEmailDomainRequest.
 * Use `create(UpdateSsoEmailDomainRequestSchema)` to create a new message.
 */
export const UpdateSsoEmailDomainRequestSchema: GenMessage<UpdateSsoEmailDomainRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_sso, 7);

/**
 * @generated from message chalk.server.v1.UpdateSsoEmailDomainResponse
 */
export type UpdateSsoEmailDomainResponse = Message<"chalk.server.v1.UpdateSsoEmailDomainResponse"> & {
  /**
   * @generated from field: chalk.server.v1.SsoEmailDomain email_domain = 1;
   */
  emailDomain?: SsoEmailDomain;
};

/**
 * Describes the message chalk.server.v1.UpdateSsoEmailDomainResponse.
 * Use `create(UpdateSsoEmailDomainResponseSchema)` to create a new message.
 */
export const UpdateSsoEmailDomainResponseSchema: GenMessage<UpdateSsoEmailDomainResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_sso, 8);

/**
 * @generated from message chalk.server.v1.DeleteSsoEmailDomainRequest
 */
export type DeleteSsoEmailDomainRequest = Message<"chalk.server.v1.DeleteSsoEmailDomainRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message chalk.server.v1.DeleteSsoEmailDomainRequest.
 * Use `create(DeleteSsoEmailDomainRequestSchema)` to create a new message.
 */
export const DeleteSsoEmailDomainRequestSchema: GenMessage<DeleteSsoEmailDomainRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_sso, 9);

/**
 * @generated from message chalk.server.v1.DeleteSsoEmailDomainResponse
 */
export type DeleteSsoEmailDomainResponse = Message<"chalk.server.v1.DeleteSsoEmailDomainResponse"> & {
};

/**
 * Describes the message chalk.server.v1.DeleteSsoEmailDomainResponse.
 * Use `create(DeleteSsoEmailDomainResponseSchema)` to create a new message.
 */
export const DeleteSsoEmailDomainResponseSchema: GenMessage<DeleteSsoEmailDomainResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_sso, 10);

/**
 * @generated from message chalk.server.v1.SignOnProviderSamlConfig
 */
export type SignOnProviderSamlConfig = Message<"chalk.server.v1.SignOnProviderSamlConfig"> & {
  /**
   * @generated from field: string issuer = 1;
   */
  issuer: string;

  /**
   * @generated from field: string idp_login_url = 2;
   */
  idpLoginUrl: string;

  /**
   * @generated from field: optional string idp_logout_url = 3;
   */
  idpLogoutUrl?: string;

  /**
   * @generated from field: string certificate = 4;
   */
  certificate: string;

  /**
   * @generated from field: optional bool is_primary_sso_config = 5;
   */
  isPrimarySsoConfig?: boolean;
};

/**
 * Describes the message chalk.server.v1.SignOnProviderSamlConfig.
 * Use `create(SignOnProviderSamlConfigSchema)` to create a new message.
 */
export const SignOnProviderSamlConfigSchema: GenMessage<SignOnProviderSamlConfig> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_sso, 11);

/**
 * @generated from message chalk.server.v1.SignOnProviderOidcConfig
 */
export type SignOnProviderOidcConfig = Message<"chalk.server.v1.SignOnProviderOidcConfig"> & {
  /**
   * @generated from field: string client_id = 1;
   */
  clientId: string;

  /**
   * @generated from field: string client_secret = 2;
   */
  clientSecret: string;
};

/**
 * Describes the message chalk.server.v1.SignOnProviderOidcConfig.
 * Use `create(SignOnProviderOidcConfigSchema)` to create a new message.
 */
export const SignOnProviderOidcConfigSchema: GenMessage<SignOnProviderOidcConfig> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_sso, 12);

/**
 * @generated from message chalk.server.v1.SignOnProviderConfiguration
 */
export type SignOnProviderConfiguration = Message<"chalk.server.v1.SignOnProviderConfiguration"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string id = 2;
   */
  id: string;

  /**
   * @generated from field: string idp_type = 3;
   */
  idpType: string;

  /**
   * @generated from field: string team_id = 6;
   */
  teamId: string;

  /**
   * @generated from oneof chalk.server.v1.SignOnProviderConfiguration.provider_config
   */
  providerConfig: {
    /**
     * @generated from field: chalk.server.v1.SignOnProviderSamlConfig saml_config = 4;
     */
    value: SignOnProviderSamlConfig;
    case: "samlConfig";
  } | {
    /**
     * @generated from field: chalk.server.v1.SignOnProviderOidcConfig oidc_config = 5;
     */
    value: SignOnProviderOidcConfig;
    case: "oidcConfig";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message chalk.server.v1.SignOnProviderConfiguration.
 * Use `create(SignOnProviderConfigurationSchema)` to create a new message.
 */
export const SignOnProviderConfigurationSchema: GenMessage<SignOnProviderConfiguration> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_sso, 13);

/**
 * @generated from message chalk.server.v1.ListSignOnProviderConfigurationsRequest
 */
export type ListSignOnProviderConfigurationsRequest = Message<"chalk.server.v1.ListSignOnProviderConfigurationsRequest"> & {
};

/**
 * Describes the message chalk.server.v1.ListSignOnProviderConfigurationsRequest.
 * Use `create(ListSignOnProviderConfigurationsRequestSchema)` to create a new message.
 */
export const ListSignOnProviderConfigurationsRequestSchema: GenMessage<ListSignOnProviderConfigurationsRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_sso, 14);

/**
 * @generated from message chalk.server.v1.ListSignOnProviderConfigurationsResponse
 */
export type ListSignOnProviderConfigurationsResponse = Message<"chalk.server.v1.ListSignOnProviderConfigurationsResponse"> & {
  /**
   * @generated from field: repeated chalk.server.v1.SignOnProviderConfiguration configurations = 1;
   */
  configurations: SignOnProviderConfiguration[];
};

/**
 * Describes the message chalk.server.v1.ListSignOnProviderConfigurationsResponse.
 * Use `create(ListSignOnProviderConfigurationsResponseSchema)` to create a new message.
 */
export const ListSignOnProviderConfigurationsResponseSchema: GenMessage<ListSignOnProviderConfigurationsResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_sso, 15);

/**
 * @generated from message chalk.server.v1.CreateSignOnProviderConfigurationRequest
 */
export type CreateSignOnProviderConfigurationRequest = Message<"chalk.server.v1.CreateSignOnProviderConfigurationRequest"> & {
  /**
   * @generated from field: chalk.server.v1.SignOnProviderConfiguration configuration = 1;
   */
  configuration?: SignOnProviderConfiguration;
};

/**
 * Describes the message chalk.server.v1.CreateSignOnProviderConfigurationRequest.
 * Use `create(CreateSignOnProviderConfigurationRequestSchema)` to create a new message.
 */
export const CreateSignOnProviderConfigurationRequestSchema: GenMessage<CreateSignOnProviderConfigurationRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_sso, 16);

/**
 * @generated from message chalk.server.v1.CreateSignOnProviderConfigurationResponse
 */
export type CreateSignOnProviderConfigurationResponse = Message<"chalk.server.v1.CreateSignOnProviderConfigurationResponse"> & {
  /**
   * @generated from field: chalk.server.v1.SignOnProviderConfiguration configuration = 1;
   */
  configuration?: SignOnProviderConfiguration;
};

/**
 * Describes the message chalk.server.v1.CreateSignOnProviderConfigurationResponse.
 * Use `create(CreateSignOnProviderConfigurationResponseSchema)` to create a new message.
 */
export const CreateSignOnProviderConfigurationResponseSchema: GenMessage<CreateSignOnProviderConfigurationResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_sso, 17);

/**
 * @generated from message chalk.server.v1.UpdateSignOnProviderConfigurationRequest
 */
export type UpdateSignOnProviderConfigurationRequest = Message<"chalk.server.v1.UpdateSignOnProviderConfigurationRequest"> & {
  /**
   * @generated from field: chalk.server.v1.SignOnProviderConfiguration configuration = 1;
   */
  configuration?: SignOnProviderConfiguration;
};

/**
 * Describes the message chalk.server.v1.UpdateSignOnProviderConfigurationRequest.
 * Use `create(UpdateSignOnProviderConfigurationRequestSchema)` to create a new message.
 */
export const UpdateSignOnProviderConfigurationRequestSchema: GenMessage<UpdateSignOnProviderConfigurationRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_sso, 18);

/**
 * @generated from message chalk.server.v1.UpdateSignOnProviderConfigurationResponse
 */
export type UpdateSignOnProviderConfigurationResponse = Message<"chalk.server.v1.UpdateSignOnProviderConfigurationResponse"> & {
  /**
   * @generated from field: chalk.server.v1.SignOnProviderConfiguration configuration = 1;
   */
  configuration?: SignOnProviderConfiguration;
};

/**
 * Describes the message chalk.server.v1.UpdateSignOnProviderConfigurationResponse.
 * Use `create(UpdateSignOnProviderConfigurationResponseSchema)` to create a new message.
 */
export const UpdateSignOnProviderConfigurationResponseSchema: GenMessage<UpdateSignOnProviderConfigurationResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_sso, 19);

/**
 * @generated from message chalk.server.v1.DeleteSignOnProviderConfigurationRequest
 */
export type DeleteSignOnProviderConfigurationRequest = Message<"chalk.server.v1.DeleteSignOnProviderConfigurationRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message chalk.server.v1.DeleteSignOnProviderConfigurationRequest.
 * Use `create(DeleteSignOnProviderConfigurationRequestSchema)` to create a new message.
 */
export const DeleteSignOnProviderConfigurationRequestSchema: GenMessage<DeleteSignOnProviderConfigurationRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_sso, 20);

/**
 * @generated from message chalk.server.v1.DeleteSignOnProviderConfigurationResponse
 */
export type DeleteSignOnProviderConfigurationResponse = Message<"chalk.server.v1.DeleteSignOnProviderConfigurationResponse"> & {
};

/**
 * Describes the message chalk.server.v1.DeleteSignOnProviderConfigurationResponse.
 * Use `create(DeleteSignOnProviderConfigurationResponseSchema)` to create a new message.
 */
export const DeleteSignOnProviderConfigurationResponseSchema: GenMessage<DeleteSignOnProviderConfigurationResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_sso, 21);

/**
 * @generated from message chalk.server.v1.GetSignOnProvidersForEmailRequest
 */
export type GetSignOnProvidersForEmailRequest = Message<"chalk.server.v1.GetSignOnProvidersForEmailRequest"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;
};

/**
 * Describes the message chalk.server.v1.GetSignOnProvidersForEmailRequest.
 * Use `create(GetSignOnProvidersForEmailRequestSchema)` to create a new message.
 */
export const GetSignOnProvidersForEmailRequestSchema: GenMessage<GetSignOnProvidersForEmailRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_sso, 22);

/**
 * @generated from message chalk.server.v1.GetSignOnProvidersForEmailResponse
 */
export type GetSignOnProvidersForEmailResponse = Message<"chalk.server.v1.GetSignOnProvidersForEmailResponse"> & {
  /**
   * @generated from field: repeated chalk.server.v1.SignOnProviderConfiguration providers = 1;
   */
  providers: SignOnProviderConfiguration[];
};

/**
 * Describes the message chalk.server.v1.GetSignOnProvidersForEmailResponse.
 * Use `create(GetSignOnProvidersForEmailResponseSchema)` to create a new message.
 */
export const GetSignOnProvidersForEmailResponseSchema: GenMessage<GetSignOnProvidersForEmailResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_sso, 23);

/**
 * @generated from message chalk.server.v1.GetSamlConfigurationByIssuerRequest
 */
export type GetSamlConfigurationByIssuerRequest = Message<"chalk.server.v1.GetSamlConfigurationByIssuerRequest"> & {
  /**
   * @generated from field: string issuer = 1;
   */
  issuer: string;
};

/**
 * Describes the message chalk.server.v1.GetSamlConfigurationByIssuerRequest.
 * Use `create(GetSamlConfigurationByIssuerRequestSchema)` to create a new message.
 */
export const GetSamlConfigurationByIssuerRequestSchema: GenMessage<GetSamlConfigurationByIssuerRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_sso, 24);

/**
 * @generated from message chalk.server.v1.GetSamlConfigurationByIssuerResponse
 */
export type GetSamlConfigurationByIssuerResponse = Message<"chalk.server.v1.GetSamlConfigurationByIssuerResponse"> & {
  /**
   * @generated from field: chalk.server.v1.SignOnProviderSamlConfig configuration = 1;
   */
  configuration?: SignOnProviderSamlConfig;

  /**
   * @generated from field: string team_id = 2;
   */
  teamId: string;
};

/**
 * Describes the message chalk.server.v1.GetSamlConfigurationByIssuerResponse.
 * Use `create(GetSamlConfigurationByIssuerResponseSchema)` to create a new message.
 */
export const GetSamlConfigurationByIssuerResponseSchema: GenMessage<GetSamlConfigurationByIssuerResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_sso, 25);

/**
 * @generated from service chalk.server.v1.SsoService
 */
export const SsoService: GenService<{
  /**
   * Creates a SCIM JWT token for the authenticated team
   *
   * @generated from rpc chalk.server.v1.SsoService.CreateScimToken
   */
  createScimToken: {
    methodKind: "unary";
    input: typeof CreateScimTokenRequestSchema;
    output: typeof CreateScimTokenResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.SsoService.ListSsoEmailDomains
   */
  listSsoEmailDomains: {
    methodKind: "unary";
    input: typeof ListSsoEmailDomainsRequestSchema;
    output: typeof ListSsoEmailDomainsResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.SsoService.CreateSsoEmailDomain
   */
  createSsoEmailDomain: {
    methodKind: "unary";
    input: typeof CreateSsoEmailDomainRequestSchema;
    output: typeof CreateSsoEmailDomainResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.SsoService.UpdateSsoEmailDomain
   */
  updateSsoEmailDomain: {
    methodKind: "unary";
    input: typeof UpdateSsoEmailDomainRequestSchema;
    output: typeof UpdateSsoEmailDomainResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.SsoService.DeleteSsoEmailDomain
   */
  deleteSsoEmailDomain: {
    methodKind: "unary";
    input: typeof DeleteSsoEmailDomainRequestSchema;
    output: typeof DeleteSsoEmailDomainResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.SsoService.ListSignOnProviderConfigurations
   */
  listSignOnProviderConfigurations: {
    methodKind: "unary";
    input: typeof ListSignOnProviderConfigurationsRequestSchema;
    output: typeof ListSignOnProviderConfigurationsResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.SsoService.CreateSignOnProviderConfiguration
   */
  createSignOnProviderConfiguration: {
    methodKind: "unary";
    input: typeof CreateSignOnProviderConfigurationRequestSchema;
    output: typeof CreateSignOnProviderConfigurationResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.SsoService.UpdateSignOnProviderConfiguration
   */
  updateSignOnProviderConfiguration: {
    methodKind: "unary";
    input: typeof UpdateSignOnProviderConfigurationRequestSchema;
    output: typeof UpdateSignOnProviderConfigurationResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.SsoService.DeleteSignOnProviderConfiguration
   */
  deleteSignOnProviderConfiguration: {
    methodKind: "unary";
    input: typeof DeleteSignOnProviderConfigurationRequestSchema;
    output: typeof DeleteSignOnProviderConfigurationResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.SsoService.GetSignOnProvidersForEmail
   */
  getSignOnProvidersForEmail: {
    methodKind: "unary";
    input: typeof GetSignOnProvidersForEmailRequestSchema;
    output: typeof GetSignOnProvidersForEmailResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.SsoService.GetSamlConfigurationByIssuer
   */
  getSamlConfigurationByIssuer: {
    methodKind: "unary";
    input: typeof GetSamlConfigurationByIssuerRequestSchema;
    output: typeof GetSamlConfigurationByIssuerResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_chalk_server_v1_sso, 0);

